
import React from 'react';

function generalAgentPrompt() {
  return `
    Bạn là Trợ lý ảo thông minh của StarGlobal 3D, đại diện cho nền tảng số hóa không gian 3D/360 hàng đầu. Hãy giao tiếp một cách chuyên nghiệp, thân thiện và hỗ trợ nhiệt tình.
    Bạn có nhiệm vụ giải đáp các thắc mắc về công nghệ số hóa 3D, các giải pháp chuyển đổi số cho doanh nghiệp và hướng dẫn người dùng trải nghiệm các tính năng trên website.
    
    StarGlobal 3D sở hữu bằng sáng chế của USPTO cho “Web/App 3D/360 tương tác thông minh”, cho phép tái hiện không gian thực dưới dạng web tương tác 3D/360, truy cập từ xa mọi lúc, mọi nơi.
    Các giải pháp của chúng tôi bao gồm:
    - Số hóa nhà máy, showroom, bảo tàng, di tích lịch sử.
    - Bản đồ số hóa 3D/360 tích hợp dữ liệu thời gian thực (IoT).
    - Công cụ đo đạc, tạo tour tham quan tự động (Auto-tour).
    
    Thông tin liên hệ:
    Hotline: (+84) 28 7303 4879 | (+84) 944 850 527
    Website: starglobal3d.com
    Email: info@starglobal3d.com
  `;
}

function generalAgentAvatar(nodes, materials, props, group) {
  const content = (
    <>
      <skinnedMesh
        geometry={nodes.AoDaiBK001.geometry}
        material={materials['DefaultMaterial.001']}
        skeleton={nodes.AoDaiBK001.skeleton}
      />
      <skinnedMesh
        geometry={nodes.AoDaiBK002.geometry}
        material={materials.TextureAoDaiXanhLa}
        skeleton={nodes.AoDaiBK002.skeleton}
      />
      <skinnedMesh
        geometry={nodes.body002.geometry}
        material={materials.arm}
        skeleton={nodes.body002.skeleton}
      />
      <skinnedMesh
        geometry={nodes.body005.geometry}
        material={materials.leg}
        skeleton={nodes.body005.skeleton}
      />
      <skinnedMesh
        geometry={nodes.body009.geometry}
        material={materials.eyelash}
        skeleton={nodes.body009.skeleton}
      />
      <skinnedMesh
        name="body016"
        geometry={nodes.body016.geometry}
        material={materials.eyelash}
        skeleton={nodes.body016.skeleton}
        morphTargetDictionary={nodes.body016.morphTargetDictionary}
        morphTargetInfluences={nodes.body016.morphTargetInfluences}
      />
      <skinnedMesh
        geometry={nodes.body018.geometry}
        material={materials.eyelash}
        skeleton={nodes.body018.skeleton}
      />
      <skinnedMesh
        name="body021"
        geometry={nodes.body021.geometry}
        material={materials.teeth}
        skeleton={nodes.body021.skeleton}
        morphTargetDictionary={nodes.body021.morphTargetDictionary}
        morphTargetInfluences={nodes.body021.morphTargetInfluences}
      />
      <skinnedMesh
        name="body022"
        geometry={nodes.body022.geometry}
        material={materials.teeth}
        skeleton={nodes.body022.skeleton}
        morphTargetDictionary={nodes.body022.morphTargetDictionary}
        morphTargetInfluences={nodes.body022.morphTargetInfluences}
      />
      <skinnedMesh
        name="body023"
        geometry={nodes.body023.geometry}
        material={materials.teeth}
        skeleton={nodes.body023.skeleton}
        morphTargetDictionary={nodes.body023.morphTargetDictionary}
        morphTargetInfluences={nodes.body023.morphTargetInfluences}
      />
      <skinnedMesh
        name="EyeLeft"
        geometry={nodes.EyeLeft.geometry}
        material={materials.cornea}
        skeleton={nodes.EyeLeft.skeleton}
        morphTargetDictionary={nodes.EyeLeft.morphTargetDictionary}
        morphTargetInfluences={nodes.EyeLeft.morphTargetInfluences}
      />
      <skinnedMesh
        name="EyeRight"
        geometry={nodes.EyeRight.geometry}
        material={materials.cornea}
        skeleton={nodes.EyeRight.skeleton}
        morphTargetDictionary={nodes.EyeRight.morphTargetDictionary}
        morphTargetInfluences={nodes.EyeRight.morphTargetInfluences}
      />
      <skinnedMesh
        name="PupilLeft"
        geometry={nodes.PupilLeft.geometry}
        material={materials.pupil}
        skeleton={nodes.PupilLeft.skeleton}
        morphTargetDictionary={nodes.PupilLeft.morphTargetDictionary}
        morphTargetInfluences={nodes.PupilLeft.morphTargetInfluences}
      />
      <skinnedMesh
        name="PupilRight"
        geometry={nodes.PupilRight.geometry}
        material={materials.pupil}
        skeleton={nodes.PupilRight.skeleton}
        morphTargetDictionary={nodes.PupilRight.morphTargetDictionary}
        morphTargetInfluences={nodes.PupilRight.morphTargetInfluences}
      />
      <skinnedMesh
        geometry={nodes.shoe.geometry}
        material={materials.shoes}
        skeleton={nodes.shoe.skeleton}
      />
      <primitive object={nodes.root} />
      <primitive object={nodes['MCH-torsoparent']} />
      <primitive object={nodes['MCH-hand_ikparentL']} />
      <primitive object={nodes['MCH-upper_arm_ik_targetparentL']} />
      <primitive object={nodes['MCH-hand_ikparentR']} />
      <primitive object={nodes['MCH-upper_arm_ik_targetparentR']} />
      <primitive object={nodes['MCH-foot_ikparentL']} />
      <primitive object={nodes['MCH-thigh_ik_targetparentL']} />
      <primitive object={nodes['MCH-foot_ikparentR']} />
      <primitive object={nodes['MCH-thigh_ik_targetparentR']} />
      <skinnedMesh
        name="body025"
        geometry={nodes.body025.geometry}
        material={materials.head}
        skeleton={nodes.body025.skeleton}
        morphTargetDictionary={nodes.body025.morphTargetDictionary}
        morphTargetInfluences={nodes.body025.morphTargetInfluences}
      />
      <skinnedMesh
        name="body025_1"
        geometry={nodes.body025_1.geometry}
        material={materials.body}
        skeleton={nodes.body025_1.skeleton}
        morphTargetDictionary={nodes.body025_1.morphTargetDictionary}
        morphTargetInfluences={nodes.body025_1.morphTargetInfluences}
      />
      <skinnedMesh
        name="body025_2"
        geometry={nodes.body025_2.geometry}
        material={materials.lacrimal}
        skeleton={nodes.body025_2.skeleton}
        morphTargetDictionary={nodes.body025_2.morphTargetDictionary}
        morphTargetInfluences={nodes.body025_2.morphTargetInfluences}
      />
      <skinnedMesh
        name="hair001"
        geometry={nodes.hair001.geometry}
        material={materials.hair_front}
        skeleton={nodes.hair001.skeleton}
        morphTargetDictionary={nodes.hair001.morphTargetDictionary}
        morphTargetInfluences={nodes.hair001.morphTargetInfluences}
      />
      <skinnedMesh
        name="hair001_1"
        geometry={nodes.hair001_1.geometry}
        material={materials.hair_back}
        skeleton={nodes.hair001_1.skeleton}
        morphTargetDictionary={nodes.hair001_1.morphTargetDictionary}
        morphTargetInfluences={nodes.hair001_1.morphTargetInfluences}
      />
    </>
  );

  if (group) {
    return (
      <group {...props} dispose={null} ref={group}>
        {content}
      </group>
    );
  }

  return content;
}

export { generalAgentPrompt, generalAgentAvatar };
